// Features that flying-squid/local replay protocol does not support at all.
export const unsupportedLocalServerFeatures = ['transactionPacketExists', 'teleportUsesOwnPacket']
